import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const locationFreightPricingCreateAtom = createMutationAtomFactory(
  'trade.locationFreightPricingCreate',
  (params: {
    locationType: 'Facility' | 'AccountAddress';
    locationId: string;
    supplierFreightEnabled: boolean;
    supplierRateFormula?: string | null;
    supplierRateVariableIds?: string | null;
    supplierChargebackFormula?: string | null;
    supplierChargebackVariableIds?: string | null;
    supplierFuelSurchargeFormula?: string | null;
    supplierFuelSurchargeVariableIds?: string | null;
    supplierFuelSurchargeMode?: string | null;
    consumerFreightEnabled: boolean;
    consumerRateFormula?: string | null;
    consumerRateVariableIds?: string | null;
    consumerChargebackFormula?: string | null;
    consumerChargebackVariableIds?: string | null;
    consumerFuelSurchargeFormula?: string | null;
    consumerFuelSurchargeVariableIds?: string | null;
    consumerFuelSurchargeMode?: string | null;
    consumerNegativeCharge: boolean;
  }) => ({
    tradeLocationFreightPricingCreate: {
      __args: {
        input: {
          locationType: params.locationType,
          locationId: params.locationId,
          supplierFreightEnabled: params.supplierFreightEnabled,
          supplierRateFormula: params.supplierRateFormula,
          supplierRateVariableIds: params.supplierRateVariableIds,
          supplierChargebackFormula: params.supplierChargebackFormula,
          supplierChargebackVariableIds: params.supplierChargebackVariableIds,
          supplierFuelSurchargeFormula: params.supplierFuelSurchargeFormula,
          supplierFuelSurchargeVariableIds:
            params.supplierFuelSurchargeVariableIds,
          supplierFuelSurchargeMode: params.supplierFuelSurchargeMode,
          consumerFreightEnabled: params.consumerFreightEnabled,
          consumerRateFormula: params.consumerRateFormula,
          consumerRateVariableIds: params.consumerRateVariableIds,
          consumerChargebackFormula: params.consumerChargebackFormula,
          consumerChargebackVariableIds: params.consumerChargebackVariableIds,
          consumerFuelSurchargeFormula: params.consumerFuelSurchargeFormula,
          consumerFuelSurchargeVariableIds:
            params.consumerFuelSurchargeVariableIds,
          consumerFuelSurchargeMode: params.consumerFuelSurchargeMode,
          consumerNegativeCharge: params.consumerNegativeCharge,
        },
      },
      id: true,
      locationId: true,
      supplierFreightEnabled: true,
      supplierRateFormula: true,
      supplierChargebackFormula: true,
      supplierFuelSurchargeFormula: true,
      supplierFuelSurchargeMode: true,
      consumerFreightEnabled: true,
      consumerRateFormula: true,
      consumerChargebackFormula: true,
      consumerFuelSurchargeFormula: true,
      consumerFuelSurchargeMode: true,
      consumerNegativeCharge: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);

export const locationFreightPricingUpdateAtom = createMutationAtomFactory(
  'trade.locationFreightPricingUpdate',
  (params: {
    id: string;
    supplierFreightEnabled?: boolean;
    supplierRateFormula?: string | null;
    supplierRateVariableIds?: string | null;
    supplierChargebackFormula?: string | null;
    supplierChargebackVariableIds?: string | null;
    supplierFuelSurchargeFormula?: string | null;
    supplierFuelSurchargeVariableIds?: string | null;
    supplierFuelSurchargeMode?: string | null;
    consumerFreightEnabled?: boolean;
    consumerRateFormula?: string | null;
    consumerRateVariableIds?: string | null;
    consumerChargebackFormula?: string | null;
    consumerChargebackVariableIds?: string | null;
    consumerFuelSurchargeFormula?: string | null;
    consumerFuelSurchargeVariableIds?: string | null;
    consumerFuelSurchargeMode?: string | null;
    consumerNegativeCharge?: boolean;
  }) => ({
    tradeLocationFreightPricingUpdate: {
      __args: {
        id: params.id,
        input: {
          supplierFreightEnabled: params.supplierFreightEnabled,
          supplierRateFormula: params.supplierRateFormula,
          supplierRateVariableIds: params.supplierRateVariableIds,
          supplierChargebackFormula: params.supplierChargebackFormula,
          supplierChargebackVariableIds: params.supplierChargebackVariableIds,
          supplierFuelSurchargeFormula: params.supplierFuelSurchargeFormula,
          supplierFuelSurchargeVariableIds:
            params.supplierFuelSurchargeVariableIds,
          supplierFuelSurchargeMode: params.supplierFuelSurchargeMode,
          consumerFreightEnabled: params.consumerFreightEnabled,
          consumerRateFormula: params.consumerRateFormula,
          consumerRateVariableIds: params.consumerRateVariableIds,
          consumerChargebackFormula: params.consumerChargebackFormula,
          consumerChargebackVariableIds: params.consumerChargebackVariableIds,
          consumerFuelSurchargeFormula: params.consumerFuelSurchargeFormula,
          consumerFuelSurchargeVariableIds:
            params.consumerFuelSurchargeVariableIds,
          consumerFuelSurchargeMode: params.consumerFuelSurchargeMode,
          consumerNegativeCharge: params.consumerNegativeCharge,
        },
      },
      id: true,
      locationId: true,
      supplierFreightEnabled: true,
      supplierRateFormula: true,
      supplierChargebackFormula: true,
      supplierFuelSurchargeFormula: true,
      supplierFuelSurchargeMode: true,
      consumerFreightEnabled: true,
      consumerRateFormula: true,
      consumerChargebackFormula: true,
      consumerFuelSurchargeFormula: true,
      consumerFuelSurchargeMode: true,
      consumerNegativeCharge: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);
